/**
 * Social media routes.
 */
import { generateTechTask } from '@/helpers/generated-tech-task'
import { RouteGroup } from '@/types/routing-types'


export default [
    generateTechTask('Google Place ID', 'google-place-id', RouteGroup.SOCIAL_MEDIA),
    generateTechTask('Campaign Social Media', 'campaign-social-media', RouteGroup.SOCIAL_MEDIA),
    generateTechTask('Department Social Media', 'department-social-media', RouteGroup.SOCIAL_MEDIA),
    {
        name: 'facebook-post-settings',
        path: '/facebook-post-settings',
        component: () => import('@/pages/FacebookPostSettings/index.vue'),
        meta: {
            title: 'Facebook Post Settings',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.SOCIAL_MEDIA
        }
    },
    {
        name: 'social-media-capture',
        path: '/social-media-capture',
        component: () => import('@/pages/SocialMediaCapture/index.vue'),
        meta: {
            title: 'Social Media Capture',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.SOCIAL_MEDIA
        }
    },
    {
        // This is a duplicate of `facebook-post-settings`.
        name: 'smc-settings',
        path: '/smc-settings',
        component: () => import('@/pages/SocialMediaCurationSettings/index.vue'),
        meta: {
            title: 'Social Media Curation Settings',
            updateTitle: true,
            displayHome: false,
            displayNav: false,
            group: RouteGroup.SOCIAL_MEDIA
        }
    },
    {
        name: 'update-department-social-media',
        path: '/update-department-social-media',
        component: () => import('@/pages/UpdateDepartmentSocialMedia/index.vue'),
        meta: {
            title: 'Update Dept. Social Media',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.SOCIAL_MEDIA
        }
    },
    {
        name: 'competitor-analysis-toolkit',
        path: '/competitor-analysis-toolkit',
        component: () => import('@/pages/CompetitorAnalysis/index.vue'),
        meta: {
            title: 'Competitor Analysis Toolkit',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.SOCIAL_MEDIA
        }
    }
]
